import { DataGatewayService } from '@core';
import { DataSourceConfig, useDataSourcesStore } from '@stores';

export const forEachUniqueSources = async (
  callback: (
    source: DataGatewayService,
    config?: DataSourceConfig
  ) => void | Promise<unknown>
) => {
  const { getPrimarySource, getSourceGateway, getSourceConfig } =
    useDataSourcesStore.getState();
  const primarySource = await getPrimarySource();
  const instances = await primarySource.getPatientInstances();
  for (const projectId in instances) {
    const source = await getSourceGateway(projectId);
    const config = getSourceConfig(projectId);
    await callback(source, config);
  }
};
